<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0 justify-content-end">
      <div class="actions-left col-lg-6 row p-0 m-0 align-items-center">
       <span class="m-0 p-0 text-left"> 
         <button v-bind:class="{'font-weight-bold': status == PENDING_STATUS}" class="status-button" @click="status = PENDING_STATUS">{{ $t('pending') }}</button> <span  v-bind:class="{'font-weight-bold': status == PENDING_STATUS}">({{pendingCount}})</span> | <button v-bind:class="{'font-weight-bold': status == ACCEPTED_STATUS}" class="status-button" @click="status = ACCEPTED_STATUS">{{ $t('accepted') }}</button> <span  v-bind:class="{'font-weight-bold': status == ACCEPTED_STATUS}">({{acceptedCount}})</span> | <button v-bind:class="{'font-weight-bold': status == REJECTED_STATUS}" class="status-button" @click="status = REJECTED_STATUS">{{ $t('rejected') }}</button> <span  v-bind:class="{'font-weight-bold': status == REJECTED_STATUS}">({{rejectedCount}})</span>
       </span>
      </div>
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="addOccurences">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="$t('occurences')" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
    <CommentsPopUp :id="commentsId" :title="commentsTitle" @closeConfirmRequested="showCommentsPopup = false" v-model="showCommentsPopup"></CommentsPopUp>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from "@/controls/PaginatedTable.vue";
import SearchBar from "@/controls/SearchBar.vue";
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase, convertToCamelCase } from "@/helpers/utils.js";
import CommentsPopUp from "@/controls/popups/CommentsPopUp.vue";

const PENDING_STATUS = "Pending";
const ACCEPTED_STATUS = "Accepted";
const REJECTED_STATUS = "Rejected";

export default {
  components: { CTableWrapper, SearchBar, CommentsPopUp },
  data () {
    return {
      searchText: '',
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'startTime', label: i18n.t('startTime'), sortable: true },
        { key: 'type', label: i18n.t('type'), sortable: true },
        { key: 'name', label: i18n.t('name'), _classes: 'font-weight-bold', sortable: true },
        { key: 'address', label: i18n.t('address'), sortable: true },
      ],
      actions: [],
      sorterValue: { column: 'id', asc: false },
      status: '',
      loading: false,
      commentsTitle: '',
      commentsId: '',
      showCommentsPopup: false,
      //
      PENDING_STATUS: PENDING_STATUS,
      ACCEPTED_STATUS: ACCEPTED_STATUS,
      REJECTED_STATUS: REJECTED_STATUS,
    }
  },
  computed: {
    ...mapState('occurences', ['getOccurencesOutput']),
    ...mapState('occurences', ['putOccurenceStatusOutput']),
    ...mapState('occurences', ['deleteOccurenceByIdOutput']),
    occurencesInfo: function() {
      return this.getOccurencesOutput ? this.getOccurencesOutput : null;
    },
    items: function()
    {
      var result = this.occurencesInfo && this.occurencesInfo.data && this.occurencesInfo.data.occurences ? this.occurencesInfo.data.occurences : [];
      result.forEach(item =>{
        item.startTime = item.startTime.replace("T", " ");
        if(item.endTime) item.endTime = item.endTime.replace("T", " ");
        item.type = this.$i18n.t(convertToCamelCase(item.type));
        if(!item.address) item.address = '';
      });

      return result;
    },
    pages: function()
    {
      return this.occurencesInfo ? this.occurencesInfo.totalPages : 1;
    },
    pendingCount: function()
    {
      return this.occurencesInfo && this.occurencesInfo.data && this.occurencesInfo.data.pending ? this.occurencesInfo.data.pending : 0;
    },
    acceptedCount: function()
    {
      return this.occurencesInfo && this.occurencesInfo.data && this.occurencesInfo.data.accepted ? this.occurencesInfo.data.accepted : 0;
    },
    rejectedCount: function()
    {
      return this.occurencesInfo && this.occurencesInfo.data && this.occurencesInfo.data.rejected ? this.occurencesInfo.data.rejected : 0;
    }
  },
  mounted: function()
  {
    if(this.$route.params.id)
    {
      this.putOccurenceStatus({id: this.$route.params.id, status: ACCEPTED_STATUS});
    }
    else
    {
      this.status = this.$route.params && this.$route.params.status ? this.$route.params.status : (localStorage.getItem('status') ? localStorage.getItem('status') : PENDING_STATUS);
    }
  },
  methods: {
    ...mapActions('occurences', ['getOccurences']),
    ...mapActions('occurences', ['putOccurenceStatus']),
    ...mapActions('occurences', ['deleteOccurenceById']),
    rowClicked (item, index) {
      this.$router.push({name: "OccurencesEdit", query: { id: item.id } });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({name: "OccurencesEdit", query: { id: item.id }});
          break;
        }
        case 'accept':
        {
          if(confirm(this.$i18n.tc('confirmAccept', `${item.name}`, { name: `${item.name} }` }))){
            this.loading = true;
            this.putOccurenceStatus({id: item.id, status: ACCEPTED_STATUS});
          }
          break;
        }
        case 'reject':
        {
          if(confirm(this.$i18n.tc('confirmReject', `${item.name}`, { name: `${item.name} }` }))){
            this.loading = true;
            this.putOccurenceStatus({id: item.id, status: REJECTED_STATUS});
          }
          break;
        }
        case 'comments':
        {
          this.commentsTitle = item.name;
          this.commentsId = item.id;
          this.showCommentsPopup = true;
          break;
        }
        case 'remove':
        {
          if(confirm(this.$i18n.tc('confirmRemove', `${item.name}`, { name: `${item.name} }` }))){
            this.deleteOccurenceById(item.id);
          }
          break;
        }
        case 'copyUrl':
        {
          var url = process.env.VUE_APP_WEB_PAGE + item.slug;
          navigator.clipboard.writeText(url);
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));
      input.status = this.status;

      this.getOccurences(input); 
    },
    addOccurences () 
    {
      router.push({ name: 'OccurencesAdd'});
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    },
  },  
  watch:
  {
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    deleteOccurenceByIdOutput: function(val)
    {
      this.loading = true;

      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    getOccurencesOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    },
    status: function(val)
    {
      // Update actions
      switch(val) {
        case PENDING_STATUS:
          {
            this.actions = [];        
          this.actions.push({ key: 'view', label: this.$i18n.t("view") });
          this.actions.push({ key: 'accept', label: this.$i18n.t("accept") });
          this.actions.push({ key: 'reject', label: this.$i18n.t("reject") });

          break;
        }
        case ACCEPTED_STATUS:
          {
            this.actions = [];        
          this.actions.push({ key: 'view', label: this.$i18n.t("view") });
          this.actions.push({ key: 'comments', label: this.$i18n.t("comments") });
          this.actions.push({ key: 'copyUrl', label: this.$i18n.t("copyUrl") });
          this.actions.push({ key: 'remove', label: this.$i18n.t("remove") });

          break;
        }
        case REJECTED_STATUS:
          {
            this.actions = [];        
          this.actions.push({ key: 'view', label: this.$i18n.t("view") });
          this.actions.push({ key: 'remove', label: this.$i18n.t("remove") });
          
          break;
        }
        default:
          {
            throw "The provided status is not supported!"; 
        }
      }
      localStorage.setItem('status', val);
      this.updateItemsRequested(1, this.itemsPerPage);
    },
    putOccurenceStatusOutput: function(val)
    {
      this.loading = true;
      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}
</style> 